import { render } from "./Intents.vue?vue&type=template&id=23b57550&lang=pug"
import script from "./Intents.vue?vue&type=script&lang=js"
export * from "./Intents.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__